import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[phx-action-row-item]',
})
export class PhxActionRowItemDirective {
  /**
   * Optional label text for the action item when it overflows into the menu.
   * Required for icon buttons to provide meaningful text in the overflow menu,
   * since icon buttons don't have visible text labels.
   *
   * @example
   * ```html
   * <button
   *   phx-action-row-item
   *   phx-icon-button
   *   [phxIcon]="editIcon"
   *   [phxActionItemLabel]="'Edit'">
   * </button>
   * ```
   */
  @Input() phxActionItemLabel?: string;

  constructor(public elementRef: ElementRef) {}
}
